const START = '_START'
const SUCCESS = '_SUCCESS'
const ERROR = '_ERROR'
const RESET = '_RESET'

export { START, SUCCESS, ERROR, RESET }
